enum RequestStatuses {
  ACTION_REQUIRED = "Action Required",
  PENDING = "Pending",
  CLOSED = "Closed",
  OPEN = "Open",
  PENDING_SCA = "Pending SCA"
}

export default RequestStatuses;
